import { Get, Set, Remove } from "../../../../../Request";

export const GetDataBlog = async (pageNumber, limit = 15, data) => {
  return await Get({
    url: "/comment/admin_list",
    data: {
      limit: limit,
      rel_type: "blog",
      ...data,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};
export const GetDataItem = async (
  pageNumber,
  limit = 15,
  limitwd,
  index,
  filter
) => {
  return await Get({
    url: "/comment/admin_list",
    data: {
      limit: limit,
      ...filter,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};
export const GetDataItemDeactive = async (
  pageNumber,
  limit = 15,
  limitwd,
  index,
  filter
) => {
  return await Get({
    url: "/comment/admin_list_deactive",
    data: {
      limit: limit,
      ...filter,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const GetDataIdBlog = async id => {
  return await Get({
    url: "/comment/admin_panel_single",
    data: {
      blog_id: id,
      SingleBlogComments: true,
    },
  }).then(data => {
    return data;
  });
};

export const GetDataIdItem = async id => {
  return await Get({
    url: "/comment/admin_single",
    data: {
      item_id: id,
      SingleItemComments: true,
    },
  }).then(data => {
    return data;
  });
};

export const toggleComment = async id => {
  return await Set({
    url: "/comment/change_status",
    data: {
      comment_id: id,
    },
  }).then(data => {
    return data;
  });
};

export const toggleCommentReplies = async id => {
  return await Set({
    url: "/commentreplies/change_status",
    data: {
      comment_id: id,
    },
  }).then(data => {
    return data;
  });
};

export const RejectComment = async id => {
  return await Set({
    url: "/comment/destroy",
    data: {
      comment_id: id,
    },
  }).then(data => {
    return data;
  });
};
export const DataSearch = async (data, limit = 15, page = null) => {
  return await Get({
    url: "/item/search",
    data: {
      limit: limit,
      ...data,
    },
    page: page,
  }).then(data => {
    return data;
  });
};
